export const AU_DATA = [
  {
    industryIdFilter: -1,
    roles: [
      {
        rank: 1,
        industryId: 1216,
        industryTitle: 'Legal',
        roleTitle: 'Partner',
        avgSalary: 222385,
        salaryGrowth: 31.3,
        jobs: 79,
      },
      {
        rank: 2,
        industryId: 1210,
        industryTitle: 'Government & Defence',
        roleTitle: 'Analyst',
        avgSalary: 127239,
        salaryGrowth: 27.4,
        jobs: 82,
      },
      {
        rank: 3,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Cosmetic Nurse Injector',
        avgSalary: 94278,
        salaryGrowth: 24.2,
        jobs: 41,
      },
      {
        rank: 4,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Management Officer',
        avgSalary: 93341,
        salaryGrowth: 19.5,
        jobs: 40,
      },
      {
        rank: 5,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Physician',
        avgSalary: 226906,
        salaryGrowth: 19.3,
        jobs: 82,
      },
      {
        rank: 6,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Product Specialist',
        avgSalary: 97724,
        salaryGrowth: 19.1,
        jobs: 37,
      },
      {
        rank: 7,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Transport Driver',
        avgSalary: 78835,
        salaryGrowth: 17.7,
        jobs: 41,
      },
      {
        rank: 8,
        industryId: 1203,
        industryTitle: 'Banking & Financial Services',
        roleTitle: 'Operations Analyst',
        avgSalary: 97256,
        salaryGrowth: 17.4,
        jobs: 46,
      },
      {
        rank: 9,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Information Technology Technician',
        avgSalary: 79262,
        salaryGrowth: 17.4,
        jobs: 48,
      },
      {
        rank: 10,
        industryId: 1203,
        industryTitle: 'Banking & Financial Services',
        roleTitle: 'Account Manager',
        avgSalary: 106982,
        salaryGrowth: 17.3,
        jobs: 39,
      },
      {
        rank: 11,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Customer Service Representative',
        avgSalary: 64200,
        salaryGrowth: 17,
        jobs: 554,
      },
      {
        rank: 12,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Trolley Return Assistant',
        avgSalary: 50500,
        salaryGrowth: 16.6,
        jobs: 40,
      },
      {
        rank: 13,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Tipper Driver',
        avgSalary: 81578,
        salaryGrowth: 15.3,
        jobs: 183,
      },
      {
        rank: 14,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Service Attendant',
        avgSalary: 63265,
        salaryGrowth: 15,
        jobs: 71,
      },
      {
        rank: 15,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Support Officer',
        avgSalary: 77826,
        salaryGrowth: 15,
        jobs: 51,
      },
      {
        rank: 16,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Assessor',
        avgSalary: 88426,
        salaryGrowth: 14.7,
        jobs: 83,
      },
      {
        rank: 17,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Project Administrator',
        avgSalary: 91760,
        salaryGrowth: 14.7,
        jobs: 83,
      },
      {
        rank: 18,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Medical Practitioner',
        avgSalary: 231450,
        salaryGrowth: 14.4,
        jobs: 66,
      },
      {
        rank: 19,
        industryId: 6076,
        industryTitle: 'Consulting & Strategy',
        roleTitle: 'Business Analyst',
        avgSalary: 125990,
        salaryGrowth: 14.2,
        jobs: 59,
      },
      {
        rank: 20,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Bricklayer',
        avgSalary: 90568,
        salaryGrowth: 14,
        jobs: 78,
      },
    ],
  },
  {
    industryIdFilter: 1202,
    roles: [
      {
        rank: 1,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Taxation Consultant',
        avgSalary: 90934,
        salaryGrowth: 13.3,
        jobs: 65,
      },
      {
        rank: 2,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Consultant',
        avgSalary: 109826,
        salaryGrowth: 11,
        jobs: 41,
      },
      {
        rank: 3,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Client Manager',
        avgSalary: 117828,
        salaryGrowth: 9.5,
        jobs: 100,
      },
      {
        rank: 4,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Payroll Team Leader',
        avgSalary: 118597,
        salaryGrowth: 7.8,
        jobs: 54,
      },
      {
        rank: 5,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Accounts Clerk',
        avgSalary: 67810,
        salaryGrowth: 7.4,
        jobs: 138,
      },
      {
        rank: 6,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Business Analyst',
        avgSalary: 122808,
        salaryGrowth: 6.9,
        jobs: 58,
      },
      {
        rank: 7,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Services Officer',
        avgSalary: 78435,
        salaryGrowth: 6.2,
        jobs: 32,
      },
      {
        rank: 8,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Payroll Coordinator',
        avgSalary: 91267,
        salaryGrowth: 5.6,
        jobs: 45,
      },
      {
        rank: 9,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Accounts Manager',
        avgSalary: 87732,
        salaryGrowth: 5.4,
        jobs: 45,
      },
      {
        rank: 10,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Payroll Administrator',
        avgSalary: 75885,
        salaryGrowth: 4.7,
        jobs: 72,
      },
      {
        rank: 11,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Payroll and Accounts Officer',
        avgSalary: 77523,
        salaryGrowth: 4.7,
        jobs: 63,
      },
      {
        rank: 12,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Administration Officer',
        avgSalary: 71732,
        salaryGrowth: 4,
        jobs: 168,
      },
      {
        rank: 13,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Reporting Manager',
        avgSalary: 164725,
        salaryGrowth: 3.9,
        jobs: 50,
      },
      {
        rank: 14,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Accounts Administrator',
        avgSalary: 72013,
        salaryGrowth: 3.9,
        jobs: 144,
      },
      {
        rank: 15,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Payroll Specialist',
        avgSalary: 98260,
        salaryGrowth: 3.8,
        jobs: 123,
      },
      {
        rank: 16,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Accounts Officer',
        avgSalary: 72866,
        salaryGrowth: 3.5,
        jobs: 608,
      },
      {
        rank: 17,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Accounts and Administration Officer',
        avgSalary: 70666,
        salaryGrowth: 3.4,
        jobs: 72,
      },
      {
        rank: 18,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Accounts Receivable Officer',
        avgSalary: 74069,
        salaryGrowth: 3.3,
        jobs: 478,
      },
      {
        rank: 19,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Financial Officer',
        avgSalary: 79031,
        salaryGrowth: 3.2,
        jobs: 635,
      },
      {
        rank: 20,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Financial Assistant',
        avgSalary: 72450,
        salaryGrowth: 3.1,
        jobs: 63,
      },
    ],
  },
  {
    industryIdFilter: 6251,
    roles: [
      {
        rank: 1,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Management Officer',
        avgSalary: 93341,
        salaryGrowth: 19.5,
        jobs: 40,
      },
      {
        rank: 2,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Secretary',
        avgSalary: 77598,
        salaryGrowth: 9.6,
        jobs: 159,
      },
      {
        rank: 3,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Construction Administrator',
        avgSalary: 77722,
        salaryGrowth: 9.5,
        jobs: 59,
      },
      {
        rank: 4,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Office Junior',
        avgSalary: 50588,
        salaryGrowth: 8.9,
        jobs: 45,
      },
      {
        rank: 5,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Compliance Officer',
        avgSalary: 80409,
        salaryGrowth: 7.2,
        jobs: 62,
      },
      {
        rank: 6,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Support Coordinator',
        avgSalary: 77358,
        salaryGrowth: 6.9,
        jobs: 164,
      },
      {
        rank: 7,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Assistant',
        avgSalary: 70218,
        salaryGrowth: 6.4,
        jobs: 64,
      },
      {
        rank: 8,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Stock Controller',
        avgSalary: 66659,
        salaryGrowth: 6.1,
        jobs: 48,
      },
      {
        rank: 9,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Scheduling Officer',
        avgSalary: 69199,
        salaryGrowth: 6.1,
        jobs: 37,
      },
      {
        rank: 10,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Client Services Coordinator',
        avgSalary: 74149,
        salaryGrowth: 6.1,
        jobs: 114,
      },
      {
        rank: 11,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Office Allrounder',
        avgSalary: 63409,
        salaryGrowth: 5.7,
        jobs: 129,
      },
      {
        rank: 12,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Administration Allrounder',
        avgSalary: 64143,
        salaryGrowth: 5.6,
        jobs: 62,
      },
      {
        rank: 13,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Maintenance Administrator',
        avgSalary: 75745,
        salaryGrowth: 5.2,
        jobs: 42,
      },
      {
        rank: 14,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Coordinator',
        avgSalary: 80654,
        salaryGrowth: 5.2,
        jobs: 145,
      },
      {
        rank: 15,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Customer Service Assistant',
        avgSalary: 61276,
        salaryGrowth: 5.2,
        jobs: 45,
      },
      {
        rank: 16,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Customer Service and Administration Officer',
        avgSalary: 64391,
        salaryGrowth: 5.1,
        jobs: 251,
      },
      {
        rank: 17,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Human Resources Administrator',
        avgSalary: 71182,
        salaryGrowth: 5.1,
        jobs: 60,
      },
      {
        rank: 18,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Business Administrator',
        avgSalary: 69682,
        salaryGrowth: 5.1,
        jobs: 52,
      },
      {
        rank: 19,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Office Administration and Customer Service Officer',
        avgSalary: 62806,
        salaryGrowth: 5,
        jobs: 35,
      },
      {
        rank: 20,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Liaison Officer',
        avgSalary: 72512,
        salaryGrowth: 5,
        jobs: 93,
      },
    ],
  },
  {
    industryIdFilter: 1201,
    roles: [
      {
        rank: 1,
        industryId: 1201,
        industryTitle: 'Advertising, Arts & Media',
        roleTitle: 'Photographer',
        avgSalary: 71173,
        salaryGrowth: 5.7,
        jobs: 112,
      },
      {
        rank: 2,
        industryId: 1201,
        industryTitle: 'Advertising, Arts & Media',
        roleTitle: 'Editor',
        avgSalary: 88509,
        salaryGrowth: 5.7,
        jobs: 105,
      },
      {
        rank: 3,
        industryId: 1201,
        industryTitle: 'Advertising, Arts & Media',
        roleTitle: 'Journalist',
        avgSalary: 71775,
        salaryGrowth: 5.2,
        jobs: 99,
      },
      {
        rank: 4,
        industryId: 1201,
        industryTitle: 'Advertising, Arts & Media',
        roleTitle: 'Reporter',
        avgSalary: 85971,
        salaryGrowth: 4.8,
        jobs: 86,
      },
      {
        rank: 5,
        industryId: 1201,
        industryTitle: 'Advertising, Arts & Media',
        roleTitle: 'Content Creator',
        avgSalary: 72164,
        salaryGrowth: 4.6,
        jobs: 36,
      },
    ],
  },
  {
    industryIdFilter: 1203,
    roles: [
      {
        rank: 1,
        industryId: 1203,
        industryTitle: 'Banking & Financial Services',
        roleTitle: 'Operations Analyst',
        avgSalary: 97256,
        salaryGrowth: 17.4,
        jobs: 46,
      },
      {
        rank: 2,
        industryId: 1203,
        industryTitle: 'Banking & Financial Services',
        roleTitle: 'Account Manager',
        avgSalary: 106982,
        salaryGrowth: 17.3,
        jobs: 39,
      },
      {
        rank: 3,
        industryId: 1203,
        industryTitle: 'Banking & Financial Services',
        roleTitle: 'Branch Manager',
        avgSalary: 107964,
        salaryGrowth: 12.8,
        jobs: 161,
      },
      {
        rank: 4,
        industryId: 1203,
        industryTitle: 'Banking & Financial Services',
        roleTitle: 'Paraplanner',
        avgSalary: 92173,
        salaryGrowth: 10.1,
        jobs: 91,
      },
      {
        rank: 5,
        industryId: 1203,
        industryTitle: 'Banking & Financial Services',
        roleTitle: 'Processor',
        avgSalary: 79111,
        salaryGrowth: 8.8,
        jobs: 63,
      },
      {
        rank: 6,
        industryId: 1203,
        industryTitle: 'Banking & Financial Services',
        roleTitle: 'Services Officer',
        avgSalary: 74168,
        salaryGrowth: 5.9,
        jobs: 235,
      },
      {
        rank: 7,
        industryId: 1203,
        industryTitle: 'Banking & Financial Services',
        roleTitle: 'Banking Consultant',
        avgSalary: 64554,
        salaryGrowth: 5.3,
        jobs: 220,
      },
      {
        rank: 8,
        industryId: 1203,
        industryTitle: 'Banking & Financial Services',
        roleTitle: 'Broker Assistant',
        avgSalary: 73065,
        salaryGrowth: 4.7,
        jobs: 34,
      },
      {
        rank: 9,
        industryId: 1203,
        industryTitle: 'Banking & Financial Services',
        roleTitle: 'Banking Specialist',
        avgSalary: 67166,
        salaryGrowth: 3.9,
        jobs: 185,
      },
      {
        rank: 10,
        industryId: 1203,
        industryTitle: 'Banking & Financial Services',
        roleTitle: 'Service Manager',
        avgSalary: 85444,
        salaryGrowth: 3.8,
        jobs: 169,
      },
      {
        rank: 11,
        industryId: 1203,
        industryTitle: 'Banking & Financial Services',
        roleTitle: 'Customer Service Representative',
        avgSalary: 64190,
        salaryGrowth: 3,
        jobs: 248,
      },
    ],
  },
  {
    industryIdFilter: 1204,
    roles: [
      {
        rank: 1,
        industryId: 1204,
        industryTitle: 'Call Centre & Customer Service',
        roleTitle: 'Appointment Setter',
        avgSalary: 71529,
        salaryGrowth: 10.8,
        jobs: 172,
      },
      {
        rank: 2,
        industryId: 1204,
        industryTitle: 'Call Centre & Customer Service',
        roleTitle: 'Customer Experience Specialist',
        avgSalary: 65253,
        salaryGrowth: 6.7,
        jobs: 75,
      },
      {
        rank: 3,
        industryId: 1204,
        industryTitle: 'Call Centre & Customer Service',
        roleTitle: 'Sales Consultant',
        avgSalary: 69307,
        salaryGrowth: 5.8,
        jobs: 144,
      },
      {
        rank: 4,
        industryId: 1204,
        industryTitle: 'Call Centre & Customer Service',
        roleTitle: 'Contact Officer',
        avgSalary: 61092,
        salaryGrowth: 5.3,
        jobs: 40,
      },
      {
        rank: 5,
        industryId: 1204,
        industryTitle: 'Call Centre & Customer Service',
        roleTitle: 'Services Officer',
        avgSalary: 70157,
        salaryGrowth: 4.7,
        jobs: 158,
      },
      {
        rank: 6,
        industryId: 1204,
        industryTitle: 'Call Centre & Customer Service',
        roleTitle: 'Sales Representative',
        avgSalary: 68730,
        salaryGrowth: 4.7,
        jobs: 111,
      },
      {
        rank: 7,
        industryId: 1204,
        industryTitle: 'Call Centre & Customer Service',
        roleTitle: 'Collections Officer',
        avgSalary: 70748,
        salaryGrowth: 4.4,
        jobs: 114,
      },
      {
        rank: 8,
        industryId: 1204,
        industryTitle: 'Call Centre & Customer Service',
        roleTitle: 'Consultant',
        avgSalary: 67449,
        salaryGrowth: 4.3,
        jobs: 37,
      },
      {
        rank: 9,
        industryId: 1204,
        industryTitle: 'Call Centre & Customer Service',
        roleTitle: 'Service Adviser',
        avgSalary: 69446,
        salaryGrowth: 4.3,
        jobs: 94,
      },
      {
        rank: 10,
        industryId: 1204,
        industryTitle: 'Call Centre & Customer Service',
        roleTitle: 'Customer Service Representative',
        avgSalary: 64558,
        salaryGrowth: 4.1,
        jobs: 2237,
      },
      {
        rank: 11,
        industryId: 1204,
        industryTitle: 'Call Centre & Customer Service',
        roleTitle: 'Customer Service Team Leader',
        avgSalary: 86739,
        salaryGrowth: 3.9,
        jobs: 82,
      },
      {
        rank: 12,
        industryId: 1204,
        industryTitle: 'Call Centre & Customer Service',
        roleTitle: 'Service Coordinator',
        avgSalary: 72770,
        salaryGrowth: 3.8,
        jobs: 44,
      },
      {
        rank: 13,
        industryId: 1204,
        industryTitle: 'Call Centre & Customer Service',
        roleTitle: 'Support Specialist',
        avgSalary: 66524,
        salaryGrowth: 3.7,
        jobs: 70,
      },
      {
        rank: 14,
        industryId: 1204,
        industryTitle: 'Call Centre & Customer Service',
        roleTitle: 'Customer Service Administrator',
        avgSalary: 64643,
        salaryGrowth: 3.7,
        jobs: 58,
      },
      {
        rank: 15,
        industryId: 1204,
        industryTitle: 'Call Centre & Customer Service',
        roleTitle: 'Support Officer',
        avgSalary: 66251,
        salaryGrowth: 3,
        jobs: 219,
      },
    ],
  },
  {
    industryIdFilter: 6163,
    roles: [
      {
        rank: 1,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Assessor',
        avgSalary: 88426,
        salaryGrowth: 14.7,
        jobs: 83,
      },
      {
        rank: 2,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Practice Leader',
        avgSalary: 112916,
        salaryGrowth: 13.8,
        jobs: 81,
      },
      {
        rank: 3,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Therapeutic Specialist',
        avgSalary: 107014,
        salaryGrowth: 12.4,
        jobs: 34,
      },
      {
        rank: 4,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Outreach Worker',
        avgSalary: 84097,
        salaryGrowth: 11.7,
        jobs: 35,
      },
      {
        rank: 5,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Enrolled Nurse',
        avgSalary: 81132,
        salaryGrowth: 10.6,
        jobs: 52,
      },
      {
        rank: 6,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Cleaner',
        avgSalary: 64748,
        salaryGrowth: 9.9,
        jobs: 112,
      },
      {
        rank: 7,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Services Team Leader',
        avgSalary: 95353,
        salaryGrowth: 9.5,
        jobs: 51,
      },
      {
        rank: 8,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Business Manager',
        avgSalary: 89478,
        salaryGrowth: 8.8,
        jobs: 49,
      },
      {
        rank: 9,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Relationship Manager',
        avgSalary: 100303,
        salaryGrowth: 8.6,
        jobs: 36,
      },
      {
        rank: 10,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Intake Officer',
        avgSalary: 82843,
        salaryGrowth: 8.4,
        jobs: 30,
      },
      {
        rank: 11,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Partner',
        avgSalary: 80160,
        salaryGrowth: 8.3,
        jobs: 151,
      },
      {
        rank: 12,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Nurse',
        avgSalary: 94450,
        salaryGrowth: 8.2,
        jobs: 151,
      },
      {
        rank: 13,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Advocate',
        avgSalary: 93044,
        salaryGrowth: 8.2,
        jobs: 114,
      },
      {
        rank: 14,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Care Employee',
        avgSalary: 66562,
        salaryGrowth: 8.1,
        jobs: 134,
      },
      {
        rank: 15,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'House Supervisor',
        avgSalary: 90800,
        salaryGrowth: 8.1,
        jobs: 33,
      },
      {
        rank: 16,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Engagement Worker',
        avgSalary: 83014,
        salaryGrowth: 8,
        jobs: 45,
      },
      {
        rank: 17,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Health Practitioner',
        avgSalary: 86467,
        salaryGrowth: 7.2,
        jobs: 49,
      },
      {
        rank: 18,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Scheduler',
        avgSalary: 74492,
        salaryGrowth: 7.1,
        jobs: 56,
      },
      {
        rank: 19,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Domestic Assistant',
        avgSalary: 66082,
        salaryGrowth: 7.1,
        jobs: 167,
      },
      {
        rank: 20,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Program Manager',
        avgSalary: 114157,
        salaryGrowth: 7,
        jobs: 131,
      },
    ],
  },
  {
    industryIdFilter: 1206,
    roles: [
      {
        rank: 1,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Project Administrator',
        avgSalary: 91760,
        salaryGrowth: 14.7,
        jobs: 83,
      },
      {
        rank: 2,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Health Safety Environment and Quality Adviser',
        avgSalary: 131153,
        salaryGrowth: 13.5,
        jobs: 122,
      },
      {
        rank: 3,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Draftsperson',
        avgSalary: 92202,
        salaryGrowth: 12.9,
        jobs: 42,
      },
      {
        rank: 4,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Front End Loader Operator',
        avgSalary: 82060,
        salaryGrowth: 12.2,
        jobs: 38,
      },
      {
        rank: 5,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Skid Steer Operator',
        avgSalary: 84162,
        salaryGrowth: 9.5,
        jobs: 42,
      },
      {
        rank: 6,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Loader Operator',
        avgSalary: 85138,
        salaryGrowth: 9.2,
        jobs: 104,
      },
      {
        rank: 7,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Pipelayer',
        avgSalary: 85756,
        salaryGrowth: 8.7,
        jobs: 45,
      },
      {
        rank: 8,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Carpenter',
        avgSalary: 101174,
        salaryGrowth: 7.9,
        jobs: 76,
      },
      {
        rank: 9,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Crew Member',
        avgSalary: 71050,
        salaryGrowth: 7.5,
        jobs: 63,
      },
      {
        rank: 10,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Rigger',
        avgSalary: 96512,
        salaryGrowth: 6.8,
        jobs: 52,
      },
      {
        rank: 11,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Truck Driver',
        avgSalary: 77952,
        salaryGrowth: 6.6,
        jobs: 411,
      },
      {
        rank: 12,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Bobcat Operator',
        avgSalary: 85655,
        salaryGrowth: 6.6,
        jobs: 50,
      },
      {
        rank: 13,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Roller Operator',
        avgSalary: 81049,
        salaryGrowth: 5.7,
        jobs: 42,
      },
      {
        rank: 14,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Leading Hand',
        avgSalary: 97907,
        salaryGrowth: 5,
        jobs: 366,
      },
      {
        rank: 15,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Building Supervisor',
        avgSalary: 110009,
        salaryGrowth: 5,
        jobs: 135,
      },
      {
        rank: 16,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Labourer',
        avgSalary: 74691,
        salaryGrowth: 4.9,
        jobs: 282,
      },
      {
        rank: 17,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Locator',
        avgSalary: 86969,
        salaryGrowth: 3.7,
        jobs: 64,
      },
      {
        rank: 18,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Civil Operator',
        avgSalary: 91597,
        salaryGrowth: 3.4,
        jobs: 71,
      },
      {
        rank: 19,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Crane Operator',
        avgSalary: 100763,
        salaryGrowth: 3.3,
        jobs: 194,
      },
      {
        rank: 20,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Cadet',
        avgSalary: 65530,
        salaryGrowth: 3,
        jobs: 56,
      },
    ],
  },
  {
    industryIdFilter: 6076,
    roles: [
      {
        rank: 1,
        industryId: 6076,
        industryTitle: 'Consulting & Strategy',
        roleTitle: 'Business Analyst',
        avgSalary: 125990,
        salaryGrowth: 14.2,
        jobs: 59,
      },
      {
        rank: 2,
        industryId: 6076,
        industryTitle: 'Consulting & Strategy',
        roleTitle: 'Policy Officer',
        avgSalary: 115438,
        salaryGrowth: 11,
        jobs: 57,
      },
    ],
  },
  {
    industryIdFilter: 1207,
    roles: [
      {
        rank: 1,
        industryId: 1207,
        industryTitle: 'Design & Architecture',
        roleTitle: 'Planner',
        avgSalary: 109570,
        salaryGrowth: 8.6,
        jobs: 326,
      },
      {
        rank: 2,
        industryId: 1207,
        industryTitle: 'Design & Architecture',
        roleTitle: 'Product Developer',
        avgSalary: 87750,
        salaryGrowth: 6,
        jobs: 40,
      },
      {
        rank: 3,
        industryId: 1207,
        industryTitle: 'Design & Architecture',
        roleTitle: 'Project Architect',
        avgSalary: 113345,
        salaryGrowth: 5.3,
        jobs: 101,
      },
      {
        rank: 4,
        industryId: 1207,
        industryTitle: 'Design & Architecture',
        roleTitle: 'Graduate of Architecture',
        avgSalary: 81519,
        salaryGrowth: 4.8,
        jobs: 68,
      },
      {
        rank: 5,
        industryId: 1207,
        industryTitle: 'Design & Architecture',
        roleTitle: 'Draftsperson',
        avgSalary: 84798,
        salaryGrowth: 4.5,
        jobs: 428,
      },
      {
        rank: 6,
        industryId: 1207,
        industryTitle: 'Design & Architecture',
        roleTitle: 'Architect',
        avgSalary: 103142,
        salaryGrowth: 3,
        jobs: 191,
      },
    ],
  },
  {
    industryIdFilter: 6123,
    roles: [
      {
        rank: 1,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Team Leader',
        avgSalary: 94875,
        salaryGrowth: 11.4,
        jobs: 71,
      },
      {
        rank: 2,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Service Manager',
        avgSalary: 82691,
        salaryGrowth: 10.2,
        jobs: 140,
      },
      {
        rank: 3,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Operations Manager',
        avgSalary: 123055,
        salaryGrowth: 9.5,
        jobs: 55,
      },
      {
        rank: 4,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Centre Manager',
        avgSalary: 92868,
        salaryGrowth: 8.2,
        jobs: 465,
      },
      {
        rank: 5,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Teachers Aide',
        avgSalary: 67664,
        salaryGrowth: 7.8,
        jobs: 141,
      },
      {
        rank: 6,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Nominated Supervisor',
        avgSalary: 93571,
        salaryGrowth: 7.8,
        jobs: 124,
      },
      {
        rank: 7,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Assistant',
        avgSalary: 66443,
        salaryGrowth: 7.4,
        jobs: 75,
      },
      {
        rank: 8,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Centre Director',
        avgSalary: 100918,
        salaryGrowth: 7.1,
        jobs: 494,
      },
      {
        rank: 9,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Outside School Hours Care Coordinator',
        avgSalary: 74396,
        salaryGrowth: 6.4,
        jobs: 530,
      },
      {
        rank: 10,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Librarian',
        avgSalary: 96327,
        salaryGrowth: 6,
        jobs: 132,
      },
      {
        rank: 11,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Second in Charge',
        avgSalary: 74258,
        salaryGrowth: 5.9,
        jobs: 53,
      },
      {
        rank: 12,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'School Officer',
        avgSalary: 66196,
        salaryGrowth: 5.7,
        jobs: 53,
      },
      {
        rank: 13,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Specialist',
        avgSalary: 103016,
        salaryGrowth: 5.6,
        jobs: 48,
      },
      {
        rank: 14,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Compliance Officer',
        avgSalary: 87816,
        salaryGrowth: 5.5,
        jobs: 37,
      },
      {
        rank: 15,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Research Fellow',
        avgSalary: 113265,
        salaryGrowth: 5.2,
        jobs: 104,
      },
      {
        rank: 16,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Early Childhood Teacher',
        avgSalary: 89148,
        salaryGrowth: 5.1,
        jobs: 2319,
      },
      {
        rank: 17,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Educator',
        avgSalary: 65784,
        salaryGrowth: 4.8,
        jobs: 8674,
      },
      {
        rank: 18,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Assistant Coordinator',
        avgSalary: 66591,
        salaryGrowth: 4.8,
        jobs: 224,
      },
      {
        rank: 19,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Designer',
        avgSalary: 104986,
        salaryGrowth: 4.5,
        jobs: 79,
      },
      {
        rank: 20,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Room Leader',
        avgSalary: 71962,
        salaryGrowth: 4.5,
        jobs: 553,
      },
    ],
  },
  {
    industryIdFilter: 1209,
    roles: [
      {
        rank: 1,
        industryId: 1209,
        industryTitle: 'Engineering',
        roleTitle: 'Sales Engineer',
        avgSalary: 109135,
        salaryGrowth: 10.1,
        jobs: 53,
      },
      {
        rank: 2,
        industryId: 1209,
        industryTitle: 'Engineering',
        roleTitle: 'Technical Officer',
        avgSalary: 99145,
        salaryGrowth: 10,
        jobs: 104,
      },
      {
        rank: 3,
        industryId: 1209,
        industryTitle: 'Engineering',
        roleTitle: 'Modeller',
        avgSalary: 118962,
        salaryGrowth: 9.9,
        jobs: 40,
      },
      {
        rank: 4,
        industryId: 1209,
        industryTitle: 'Engineering',
        roleTitle: 'Engineering Lead',
        avgSalary: 176121,
        salaryGrowth: 9.2,
        jobs: 58,
      },
      {
        rank: 5,
        industryId: 1209,
        industryTitle: 'Engineering',
        roleTitle: 'Development Engineer',
        avgSalary: 106150,
        salaryGrowth: 7.3,
        jobs: 79,
      },
      {
        rank: 6,
        industryId: 1209,
        industryTitle: 'Engineering',
        roleTitle: 'Automation Engineer',
        avgSalary: 130538,
        salaryGrowth: 6.2,
        jobs: 76,
      },
      {
        rank: 7,
        industryId: 1209,
        industryTitle: 'Engineering',
        roleTitle: 'Controls Engineer',
        avgSalary: 133940,
        salaryGrowth: 3.9,
        jobs: 55,
      },
      {
        rank: 8,
        industryId: 1209,
        industryTitle: 'Engineering',
        roleTitle: 'Licenced Aircraft Maintenance Engineer',
        avgSalary: 133518,
        salaryGrowth: 3.8,
        jobs: 124,
      },
    ],
  },
  {
    industryIdFilter: 6205,
    roles: [
      {
        rank: 1,
        industryId: 6205,
        industryTitle: 'Farming, Animals & Conservation',
        roleTitle: 'Veterinarian',
        avgSalary: 116310,
        salaryGrowth: 9.1,
        jobs: 112,
      },
      {
        rank: 2,
        industryId: 6205,
        industryTitle: 'Farming, Animals & Conservation',
        roleTitle: 'Stockperson',
        avgSalary: 67859,
        salaryGrowth: 7.6,
        jobs: 37,
      },
      {
        rank: 3,
        industryId: 6205,
        industryTitle: 'Farming, Animals & Conservation',
        roleTitle: 'Groomer',
        avgSalary: 66269,
        salaryGrowth: 6.9,
        jobs: 135,
      },
      {
        rank: 4,
        industryId: 6205,
        industryTitle: 'Farming, Animals & Conservation',
        roleTitle: 'Machine Operator',
        avgSalary: 70659,
        salaryGrowth: 6.2,
        jobs: 70,
      },
      {
        rank: 5,
        industryId: 6205,
        industryTitle: 'Farming, Animals & Conservation',
        roleTitle: 'Animal Attendant',
        avgSalary: 59687,
        salaryGrowth: 6.1,
        jobs: 72,
      },
      {
        rank: 6,
        industryId: 6205,
        industryTitle: 'Farming, Animals & Conservation',
        roleTitle: 'Nurse',
        avgSalary: 64170,
        salaryGrowth: 5.4,
        jobs: 342,
      },
      {
        rank: 7,
        industryId: 6205,
        industryTitle: 'Farming, Animals & Conservation',
        roleTitle: 'Station Hand',
        avgSalary: 62392,
        salaryGrowth: 5.1,
        jobs: 58,
      },
      {
        rank: 8,
        industryId: 6205,
        industryTitle: 'Farming, Animals & Conservation',
        roleTitle: 'Nursery Hand',
        avgSalary: 58887,
        salaryGrowth: 4.1,
        jobs: 61,
      },
      {
        rank: 9,
        industryId: 6205,
        industryTitle: 'Farming, Animals & Conservation',
        roleTitle: 'Receptionist',
        avgSalary: 59271,
        salaryGrowth: 4,
        jobs: 33,
      },
      {
        rank: 10,
        industryId: 6205,
        industryTitle: 'Farming, Animals & Conservation',
        roleTitle: 'Farm Manager',
        avgSalary: 97770,
        salaryGrowth: 3.3,
        jobs: 170,
      },
    ],
  },
  {
    industryIdFilter: 1210,
    roles: [
      {
        rank: 1,
        industryId: 1210,
        industryTitle: 'Government & Defence',
        roleTitle: 'Analyst',
        avgSalary: 127239,
        salaryGrowth: 27.4,
        jobs: 82,
      },
      {
        rank: 2,
        industryId: 1210,
        industryTitle: 'Government & Defence',
        roleTitle: 'Maintenance Officer',
        avgSalary: 74934,
        salaryGrowth: 13,
        jobs: 37,
      },
      {
        rank: 3,
        industryId: 1210,
        industryTitle: 'Government & Defence',
        roleTitle: 'Technical Officer',
        avgSalary: 95059,
        salaryGrowth: 10,
        jobs: 30,
      },
      {
        rank: 4,
        industryId: 1210,
        industryTitle: 'Government & Defence',
        roleTitle: 'Inspector',
        avgSalary: 108565,
        salaryGrowth: 8.6,
        jobs: 70,
      },
      {
        rank: 5,
        industryId: 1210,
        industryTitle: 'Government & Defence',
        roleTitle: 'Parking Officer',
        avgSalary: 73661,
        salaryGrowth: 8.3,
        jobs: 30,
      },
      {
        rank: 6,
        industryId: 1210,
        industryTitle: 'Government & Defence',
        roleTitle: 'Services Officer',
        avgSalary: 80179,
        salaryGrowth: 8.1,
        jobs: 67,
      },
      {
        rank: 7,
        industryId: 1210,
        industryTitle: 'Government & Defence',
        roleTitle: 'Plant Operator',
        avgSalary: 70261,
        salaryGrowth: 6.9,
        jobs: 35,
      },
      {
        rank: 8,
        industryId: 1210,
        industryTitle: 'Government & Defence',
        roleTitle: 'Engagement Officer',
        avgSalary: 98137,
        salaryGrowth: 6.8,
        jobs: 50,
      },
      {
        rank: 9,
        industryId: 1210,
        industryTitle: 'Government & Defence',
        roleTitle: 'Policy Officer',
        avgSalary: 113524,
        salaryGrowth: 6.6,
        jobs: 58,
      },
      {
        rank: 10,
        industryId: 1210,
        industryTitle: 'Government & Defence',
        roleTitle: 'Planner',
        avgSalary: 105748,
        salaryGrowth: 6.4,
        jobs: 87,
      },
      {
        rank: 11,
        industryId: 1210,
        industryTitle: 'Government & Defence',
        roleTitle: 'Health Officer',
        avgSalary: 97436,
        salaryGrowth: 5.5,
        jobs: 55,
      },
      {
        rank: 12,
        industryId: 1210,
        industryTitle: 'Government & Defence',
        roleTitle: 'Governance Officer',
        avgSalary: 100108,
        salaryGrowth: 4.4,
        jobs: 48,
      },
      {
        rank: 13,
        industryId: 1210,
        industryTitle: 'Government & Defence',
        roleTitle: 'Assistant Director',
        avgSalary: 126717,
        salaryGrowth: 4.1,
        jobs: 273,
      },
      {
        rank: 14,
        industryId: 1210,
        industryTitle: 'Government & Defence',
        roleTitle: 'Adviser',
        avgSalary: 121992,
        salaryGrowth: 3.9,
        jobs: 92,
      },
      {
        rank: 15,
        industryId: 1210,
        industryTitle: 'Government & Defence',
        roleTitle: 'Coordinator',
        avgSalary: 114064,
        salaryGrowth: 3.9,
        jobs: 131,
      },
      {
        rank: 16,
        industryId: 1210,
        industryTitle: 'Government & Defence',
        roleTitle: 'Officer',
        avgSalary: 93058,
        salaryGrowth: 3.8,
        jobs: 117,
      },
      {
        rank: 17,
        industryId: 1210,
        industryTitle: 'Government & Defence',
        roleTitle: 'Ranger',
        avgSalary: 83888,
        salaryGrowth: 3,
        jobs: 60,
      },
    ],
  },
  {
    industryIdFilter: 1211,
    roles: [
      {
        rank: 1,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Cosmetic Nurse Injector',
        avgSalary: 94278,
        salaryGrowth: 24.2,
        jobs: 41,
      },
      {
        rank: 2,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Physician',
        avgSalary: 226906,
        salaryGrowth: 19.3,
        jobs: 82,
      },
      {
        rank: 3,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Medical Practitioner',
        avgSalary: 231450,
        salaryGrowth: 14.4,
        jobs: 66,
      },
      {
        rank: 4,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Care Attendant',
        avgSalary: 69293,
        salaryGrowth: 12.9,
        jobs: 37,
      },
      {
        rank: 5,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Customer Service Representative',
        avgSalary: 68434,
        salaryGrowth: 12.6,
        jobs: 51,
      },
      {
        rank: 6,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Careworker',
        avgSalary: 68273,
        salaryGrowth: 11.5,
        jobs: 305,
      },
      {
        rank: 7,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Food Services Assistant',
        avgSalary: 59213,
        salaryGrowth: 9.4,
        jobs: 71,
      },
      {
        rank: 8,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Assessor',
        avgSalary: 96651,
        salaryGrowth: 8.8,
        jobs: 217,
      },
      {
        rank: 9,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Dental Officer',
        avgSalary: 153595,
        salaryGrowth: 8.7,
        jobs: 32,
      },
      {
        rank: 10,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Cleaner',
        avgSalary: 58263,
        salaryGrowth: 8.2,
        jobs: 51,
      },
      {
        rank: 11,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Sonographer',
        avgSalary: 138718,
        salaryGrowth: 7.9,
        jobs: 733,
      },
      {
        rank: 12,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Dispensary Assistant',
        avgSalary: 57659,
        salaryGrowth: 7.8,
        jobs: 50,
      },
      {
        rank: 13,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Chiropractic Assistant',
        avgSalary: 62145,
        salaryGrowth: 7.4,
        jobs: 42,
      },
      {
        rank: 14,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Central Sterile Services Department Technician',
        avgSalary: 66178,
        salaryGrowth: 7.1,
        jobs: 69,
      },
      {
        rank: 15,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Technologist',
        avgSalary: 105908,
        salaryGrowth: 7.1,
        jobs: 176,
      },
      {
        rank: 16,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Technician',
        avgSalary: 77653,
        salaryGrowth: 6.7,
        jobs: 46,
      },
      {
        rank: 17,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Clinical Lead',
        avgSalary: 119205,
        salaryGrowth: 6.4,
        jobs: 138,
      },
      {
        rank: 18,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Health Practitioner',
        avgSalary: 99134,
        salaryGrowth: 6.4,
        jobs: 64,
      },
      {
        rank: 19,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Pharmacy Technician',
        avgSalary: 64073,
        salaryGrowth: 6.3,
        jobs: 133,
      },
      {
        rank: 20,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Practitioner',
        avgSalary: 103715,
        salaryGrowth: 6.2,
        jobs: 53,
      },
    ],
  },
  {
    industryIdFilter: 1212,
    roles: [
      {
        rank: 1,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Service Attendant',
        avgSalary: 63265,
        salaryGrowth: 15,
        jobs: 71,
      },
      {
        rank: 2,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Assistant',
        avgSalary: 70953,
        salaryGrowth: 12.3,
        jobs: 50,
      },
      {
        rank: 3,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Artist',
        avgSalary: 58644,
        salaryGrowth: 10.8,
        jobs: 33,
      },
      {
        rank: 4,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Team Member',
        avgSalary: 56759,
        salaryGrowth: 10.7,
        jobs: 152,
      },
      {
        rank: 5,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Chef Manager',
        avgSalary: 80999,
        salaryGrowth: 8.1,
        jobs: 129,
      },
      {
        rank: 6,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Kitchen Manager',
        avgSalary: 78556,
        salaryGrowth: 7.9,
        jobs: 78,
      },
      {
        rank: 7,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Business Development Manager',
        avgSalary: 92163,
        salaryGrowth: 7.8,
        jobs: 31,
      },
      {
        rank: 8,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Gaming Supervisor',
        avgSalary: 74447,
        salaryGrowth: 7.3,
        jobs: 57,
      },
      {
        rank: 9,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Front Office Supervisor',
        avgSalary: 66712,
        salaryGrowth: 7.2,
        jobs: 59,
      },
      {
        rank: 10,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Cafe Attendant',
        avgSalary: 58964,
        salaryGrowth: 7.1,
        jobs: 61,
      },
      {
        rank: 11,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Supervisor',
        avgSalary: 67043,
        salaryGrowth: 7.1,
        jobs: 140,
      },
      {
        rank: 12,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Guide',
        avgSalary: 72461,
        salaryGrowth: 7,
        jobs: 109,
      },
      {
        rank: 13,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Caretaker',
        avgSalary: 68533,
        salaryGrowth: 7,
        jobs: 41,
      },
      {
        rank: 14,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Team Leader',
        avgSalary: 71535,
        salaryGrowth: 6.8,
        jobs: 81,
      },
      {
        rank: 15,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Shift Supervisor',
        avgSalary: 66065,
        salaryGrowth: 6.7,
        jobs: 69,
      },
      {
        rank: 16,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Events Manager',
        avgSalary: 84090,
        salaryGrowth: 6.7,
        jobs: 65,
      },
      {
        rank: 17,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Travel Consultant',
        avgSalary: 73020,
        salaryGrowth: 6.7,
        jobs: 259,
      },
      {
        rank: 18,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Floor Staff',
        avgSalary: 66369,
        salaryGrowth: 6.4,
        jobs: 42,
      },
      {
        rank: 19,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Food Services Assistant',
        avgSalary: 56243,
        salaryGrowth: 6.3,
        jobs: 383,
      },
      {
        rank: 20,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Bar Manager',
        avgSalary: 79493,
        salaryGrowth: 6.3,
        jobs: 179,
      },
    ],
  },
  {
    industryIdFilter: 1213,
    roles: [
      {
        rank: 1,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'Consultant',
        avgSalary: 112692,
        salaryGrowth: 12.5,
        jobs: 76,
      },
      {
        rank: 2,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'Safety Adviser',
        avgSalary: 113807,
        salaryGrowth: 11.3,
        jobs: 40,
      },
      {
        rank: 3,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'Learning and Development Coordinator',
        avgSalary: 86721,
        salaryGrowth: 10.9,
        jobs: 49,
      },
      {
        rank: 4,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'Work Health and Safety Coordinator',
        avgSalary: 96961,
        salaryGrowth: 9.9,
        jobs: 81,
      },
      {
        rank: 5,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'Human Resources Assistant',
        avgSalary: 73018,
        salaryGrowth: 7.6,
        jobs: 43,
      },
      {
        rank: 6,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'Human Resources Generalist',
        avgSalary: 100717,
        salaryGrowth: 6.7,
        jobs: 93,
      },
      {
        rank: 7,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'Resourcer',
        avgSalary: 72379,
        salaryGrowth: 5.5,
        jobs: 73,
      },
      {
        rank: 8,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'Human Resources Business Partner',
        avgSalary: 127469,
        salaryGrowth: 5.4,
        jobs: 631,
      },
      {
        rank: 9,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'Support Officer',
        avgSalary: 76980,
        salaryGrowth: 5.3,
        jobs: 41,
      },
      {
        rank: 10,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'Recruitment Coordinator',
        avgSalary: 77511,
        salaryGrowth: 4.8,
        jobs: 139,
      },
      {
        rank: 11,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'Recruitment Officer',
        avgSalary: 79811,
        salaryGrowth: 4.6,
        jobs: 112,
      },
      {
        rank: 12,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'Learning and Development Specialist',
        avgSalary: 115074,
        salaryGrowth: 4.5,
        jobs: 40,
      },
      {
        rank: 13,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'People and Culture Administrator',
        avgSalary: 70932,
        salaryGrowth: 4.4,
        jobs: 49,
      },
      {
        rank: 14,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'Administration Officer',
        avgSalary: 73454,
        salaryGrowth: 4.4,
        jobs: 60,
      },
      {
        rank: 15,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'Human Resources Coordinator',
        avgSalary: 81433,
        salaryGrowth: 4.3,
        jobs: 296,
      },
      {
        rank: 16,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'Human Resources Administrator',
        avgSalary: 71992,
        salaryGrowth: 4,
        jobs: 137,
      },
      {
        rank: 17,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'Acquisition Specialist',
        avgSalary: 97326,
        salaryGrowth: 3.8,
        jobs: 111,
      },
      {
        rank: 18,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'Partner',
        avgSalary: 121735,
        salaryGrowth: 3.6,
        jobs: 922,
      },
      {
        rank: 19,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'Account Manager',
        avgSalary: 88015,
        salaryGrowth: 3.3,
        jobs: 56,
      },
      {
        rank: 20,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'Recruitment Consultant',
        avgSalary: 82925,
        salaryGrowth: 3.2,
        jobs: 1243,
      },
    ],
  },
  {
    industryIdFilter: 6281,
    roles: [
      {
        rank: 1,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Information Technology Technician',
        avgSalary: 79262,
        salaryGrowth: 17.4,
        jobs: 48,
      },
      {
        rank: 2,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Writer',
        avgSalary: 118636,
        salaryGrowth: 11.5,
        jobs: 54,
      },
      {
        rank: 3,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Support Consultant',
        avgSalary: 86175,
        salaryGrowth: 10.2,
        jobs: 40,
      },
      {
        rank: 4,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Engineering Manager',
        avgSalary: 190471,
        salaryGrowth: 9.5,
        jobs: 98,
      },
      {
        rank: 5,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Application Suport Analyst',
        avgSalary: 97364,
        salaryGrowth: 8.3,
        jobs: 75,
      },
      {
        rank: 6,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Engineering Lead',
        avgSalary: 179554,
        salaryGrowth: 7.8,
        jobs: 84,
      },
      {
        rank: 7,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Telecommunications Technician',
        avgSalary: 83190,
        salaryGrowth: 7.8,
        jobs: 40,
      },
      {
        rank: 8,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Support Engineer',
        avgSalary: 89663,
        salaryGrowth: 7.4,
        jobs: 430,
      },
      {
        rank: 9,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Support Analyst',
        avgSalary: 87150,
        salaryGrowth: 7,
        jobs: 216,
      },
      {
        rank: 10,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Service Desk Officer',
        avgSalary: 76755,
        salaryGrowth: 6.7,
        jobs: 43,
      },
      {
        rank: 11,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Information Technology Officer',
        avgSalary: 81052,
        salaryGrowth: 3.7,
        jobs: 45,
      },
      {
        rank: 12,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Support Officer',
        avgSalary: 80282,
        salaryGrowth: 3.5,
        jobs: 376,
      },
      {
        rank: 13,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Application Specialist',
        avgSalary: 124577,
        salaryGrowth: 3.4,
        jobs: 71,
      },
      {
        rank: 14,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Service Desk Analyst',
        avgSalary: 75659,
        salaryGrowth: 3.1,
        jobs: 159,
      },
      {
        rank: 15,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Project Coordinator',
        avgSalary: 97822,
        salaryGrowth: 3,
        jobs: 83,
      },
    ],
  },
  {
    industryIdFilter: 1214,
    roles: [
      {
        rank: 1,
        industryId: 1214,
        industryTitle: 'Insurance & Superannuation',
        roleTitle: 'Team Leader',
        avgSalary: 119947,
        salaryGrowth: 8.9,
        jobs: 41,
      },
      {
        rank: 2,
        industryId: 1214,
        industryTitle: 'Insurance & Superannuation',
        roleTitle: 'Client Executive',
        avgSalary: 94318,
        salaryGrowth: 8.8,
        jobs: 41,
      },
      {
        rank: 3,
        industryId: 1214,
        industryTitle: 'Insurance & Superannuation',
        roleTitle: 'Case Manager',
        avgSalary: 92391,
        salaryGrowth: 7,
        jobs: 176,
      },
      {
        rank: 4,
        industryId: 1214,
        industryTitle: 'Insurance & Superannuation',
        roleTitle: 'Investigator',
        avgSalary: 93738,
        salaryGrowth: 6.5,
        jobs: 54,
      },
      {
        rank: 5,
        industryId: 1214,
        industryTitle: 'Insurance & Superannuation',
        roleTitle: 'Claims Adviser',
        avgSalary: 85643,
        salaryGrowth: 6.1,
        jobs: 46,
      },
      {
        rank: 6,
        industryId: 1214,
        industryTitle: 'Insurance & Superannuation',
        roleTitle: 'Account Executive',
        avgSalary: 95613,
        salaryGrowth: 3.2,
        jobs: 217,
      },
    ],
  },
  {
    industryIdFilter: 1216,
    roles: [
      {
        rank: 1,
        industryId: 1216,
        industryTitle: 'Legal',
        roleTitle: 'Partner',
        avgSalary: 222385,
        salaryGrowth: 31.3,
        jobs: 79,
      },
      {
        rank: 2,
        industryId: 1216,
        industryTitle: 'Legal',
        roleTitle: 'Conveyancing Assistant',
        avgSalary: 68145,
        salaryGrowth: 12.1,
        jobs: 38,
      },
      {
        rank: 3,
        industryId: 1216,
        industryTitle: 'Legal',
        roleTitle: 'Law Graduate',
        avgSalary: 77056,
        salaryGrowth: 10.1,
        jobs: 54,
      },
      {
        rank: 4,
        industryId: 1216,
        industryTitle: 'Legal',
        roleTitle: 'Migration Agent',
        avgSalary: 94406,
        salaryGrowth: 9.4,
        jobs: 134,
      },
      {
        rank: 5,
        industryId: 1216,
        industryTitle: 'Legal',
        roleTitle: 'Conveyancer',
        avgSalary: 86649,
        salaryGrowth: 9.1,
        jobs: 234,
      },
      {
        rank: 6,
        industryId: 1216,
        industryTitle: 'Legal',
        roleTitle: 'Legal Officer',
        avgSalary: 136170,
        salaryGrowth: 9,
        jobs: 98,
      },
      {
        rank: 7,
        industryId: 1216,
        industryTitle: 'Legal',
        roleTitle: 'Administration Officer',
        avgSalary: 71566,
        salaryGrowth: 8.4,
        jobs: 72,
      },
      {
        rank: 8,
        industryId: 1216,
        industryTitle: 'Legal',
        roleTitle: 'Personal Assistant',
        avgSalary: 86409,
        salaryGrowth: 7.2,
        jobs: 64,
      },
      {
        rank: 9,
        industryId: 1216,
        industryTitle: 'Legal',
        roleTitle: 'Conveyancing Clerk',
        avgSalary: 75067,
        salaryGrowth: 6.5,
        jobs: 31,
      },
      {
        rank: 10,
        industryId: 1216,
        industryTitle: 'Legal',
        roleTitle: 'Secretary',
        avgSalary: 80927,
        salaryGrowth: 5.8,
        jobs: 552,
      },
      {
        rank: 11,
        industryId: 1216,
        industryTitle: 'Legal',
        roleTitle: 'Paralegal',
        avgSalary: 80964,
        salaryGrowth: 5.7,
        jobs: 680,
      },
      {
        rank: 12,
        industryId: 1216,
        industryTitle: 'Legal',
        roleTitle: 'Law Clerk',
        avgSalary: 69719,
        salaryGrowth: 4.6,
        jobs: 107,
      },
      {
        rank: 13,
        industryId: 1216,
        industryTitle: 'Legal',
        roleTitle: 'Legal Administrator',
        avgSalary: 74270,
        salaryGrowth: 3.5,
        jobs: 62,
      },
    ],
  },
  {
    industryIdFilter: 6092,
    roles: [
      {
        rank: 1,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Transport Driver',
        avgSalary: 78835,
        salaryGrowth: 17.7,
        jobs: 41,
      },
      {
        rank: 2,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Tipper Driver',
        avgSalary: 81578,
        salaryGrowth: 15.3,
        jobs: 183,
      },
      {
        rank: 3,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Manufacturing Operator',
        avgSalary: 74362,
        salaryGrowth: 12.4,
        jobs: 47,
      },
      {
        rank: 4,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Supervisor',
        avgSalary: 91493,
        salaryGrowth: 12.2,
        jobs: 118,
      },
      {
        rank: 5,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Technician',
        avgSalary: 79883,
        salaryGrowth: 12.1,
        jobs: 39,
      },
      {
        rank: 6,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Computer Numerical Control Machine Operator',
        avgSalary: 76809,
        salaryGrowth: 11,
        jobs: 77,
      },
      {
        rank: 7,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Fleet Coordinator',
        avgSalary: 88326,
        salaryGrowth: 10.7,
        jobs: 36,
      },
      {
        rank: 8,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Quality Assurance Manager',
        avgSalary: 120309,
        salaryGrowth: 10.3,
        jobs: 65,
      },
      {
        rank: 9,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Support Officer',
        avgSalary: 78518,
        salaryGrowth: 10.1,
        jobs: 64,
      },
      {
        rank: 10,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Quality Assurance Coordinator',
        avgSalary: 83045,
        salaryGrowth: 9.5,
        jobs: 40,
      },
      {
        rank: 11,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Warehouse Officer',
        avgSalary: 69089,
        salaryGrowth: 9.4,
        jobs: 141,
      },
      {
        rank: 12,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Warehouse Team Member',
        avgSalary: 61555,
        salaryGrowth: 8.6,
        jobs: 166,
      },
      {
        rank: 13,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Production Team Leader',
        avgSalary: 75564,
        salaryGrowth: 8.2,
        jobs: 56,
      },
      {
        rank: 14,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Stacker Operator',
        avgSalary: 79631,
        salaryGrowth: 7.6,
        jobs: 58,
      },
      {
        rank: 15,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Truck Driver',
        avgSalary: 77117,
        salaryGrowth: 7.4,
        jobs: 6541,
      },
      {
        rank: 16,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Manufacturer',
        avgSalary: 64000,
        salaryGrowth: 7.3,
        jobs: 49,
      },
      {
        rank: 17,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Local Driver',
        avgSalary: 65240,
        salaryGrowth: 7.2,
        jobs: 84,
      },
      {
        rank: 18,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Procurement Coordinator',
        avgSalary: 93108,
        salaryGrowth: 7.2,
        jobs: 46,
      },
      {
        rank: 19,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Loader',
        avgSalary: 69077,
        salaryGrowth: 7.1,
        jobs: 55,
      },
      {
        rank: 20,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Quality Control Officer',
        avgSalary: 70155,
        salaryGrowth: 7.1,
        jobs: 43,
      },
    ],
  },
  {
    industryIdFilter: 1218,
    roles: [
      {
        rank: 1,
        industryId: 1218,
        industryTitle: 'Marketing & Communications',
        roleTitle: 'Search Engine Optimisation Specialist',
        avgSalary: 88734,
        salaryGrowth: 11,
        jobs: 52,
      },
      {
        rank: 2,
        industryId: 1218,
        industryTitle: 'Marketing & Communications',
        roleTitle: 'Content Creator',
        avgSalary: 75131,
        salaryGrowth: 8.4,
        jobs: 236,
      },
      {
        rank: 3,
        industryId: 1218,
        industryTitle: 'Marketing & Communications',
        roleTitle: 'Coordinator',
        avgSalary: 83394,
        salaryGrowth: 8.2,
        jobs: 66,
      },
      {
        rank: 4,
        industryId: 1218,
        industryTitle: 'Marketing & Communications',
        roleTitle: 'Communications Coordinator',
        avgSalary: 89314,
        salaryGrowth: 7.9,
        jobs: 102,
      },
      {
        rank: 5,
        industryId: 1218,
        industryTitle: 'Marketing & Communications',
        roleTitle: 'Sales and Marketing Coordinator',
        avgSalary: 76552,
        salaryGrowth: 6.7,
        jobs: 40,
      },
      {
        rank: 6,
        industryId: 1218,
        industryTitle: 'Marketing & Communications',
        roleTitle: 'Media Specialist',
        avgSalary: 86969,
        salaryGrowth: 6.1,
        jobs: 95,
      },
      {
        rank: 7,
        industryId: 1218,
        industryTitle: 'Marketing & Communications',
        roleTitle: 'Communications Officer',
        avgSalary: 95090,
        salaryGrowth: 5.9,
        jobs: 189,
      },
      {
        rank: 8,
        industryId: 1218,
        industryTitle: 'Marketing & Communications',
        roleTitle: 'Marketing Executive',
        avgSalary: 85234,
        salaryGrowth: 5.8,
        jobs: 208,
      },
      {
        rank: 9,
        industryId: 1218,
        industryTitle: 'Marketing & Communications',
        roleTitle: 'Designer',
        avgSalary: 82227,
        salaryGrowth: 5.4,
        jobs: 114,
      },
      {
        rank: 10,
        industryId: 1218,
        industryTitle: 'Marketing & Communications',
        roleTitle: 'Marketer',
        avgSalary: 83890,
        salaryGrowth: 4.3,
        jobs: 46,
      },
      {
        rank: 11,
        industryId: 1218,
        industryTitle: 'Marketing & Communications',
        roleTitle: 'Marketing and Communications Officer',
        avgSalary: 82065,
        salaryGrowth: 3.9,
        jobs: 51,
      },
      {
        rank: 12,
        industryId: 1218,
        industryTitle: 'Marketing & Communications',
        roleTitle: 'Producer',
        avgSalary: 89393,
        salaryGrowth: 3.8,
        jobs: 81,
      },
      {
        rank: 13,
        industryId: 1218,
        industryTitle: 'Marketing & Communications',
        roleTitle: 'Events Officer',
        avgSalary: 84349,
        salaryGrowth: 3.6,
        jobs: 52,
      },
      {
        rank: 14,
        industryId: 1218,
        industryTitle: 'Marketing & Communications',
        roleTitle: 'eCommerce Manager',
        avgSalary: 119188,
        salaryGrowth: 3.4,
        jobs: 58,
      },
      {
        rank: 15,
        industryId: 1218,
        industryTitle: 'Marketing & Communications',
        roleTitle: 'Project Manager',
        avgSalary: 113083,
        salaryGrowth: 3.2,
        jobs: 50,
      },
      {
        rank: 16,
        industryId: 1218,
        industryTitle: 'Marketing & Communications',
        roleTitle: 'Events Manager',
        avgSalary: 96428,
        salaryGrowth: 3.2,
        jobs: 88,
      },
      {
        rank: 17,
        industryId: 1218,
        industryTitle: 'Marketing & Communications',
        roleTitle: 'Marketing Officer',
        avgSalary: 79757,
        salaryGrowth: 3,
        jobs: 118,
      },
      {
        rank: 18,
        industryId: 1218,
        industryTitle: 'Marketing & Communications',
        roleTitle: 'Events Coordinator',
        avgSalary: 76450,
        salaryGrowth: 3,
        jobs: 168,
      },
    ],
  },
  {
    industryIdFilter: 1219,
    roles: [
      {
        rank: 1,
        industryId: 1219,
        industryTitle: 'Mining, Resources & Energy',
        roleTitle: 'Health Safety Environment and Quality Adviser',
        avgSalary: 143714,
        salaryGrowth: 11.7,
        jobs: 57,
      },
      {
        rank: 2,
        industryId: 1219,
        industryTitle: 'Mining, Resources & Energy',
        roleTitle: 'Crew',
        avgSalary: 119282,
        salaryGrowth: 11,
        jobs: 133,
      },
      {
        rank: 3,
        industryId: 1219,
        industryTitle: 'Mining, Resources & Energy',
        roleTitle: 'Grader Operator',
        avgSalary: 124162,
        salaryGrowth: 9.9,
        jobs: 45,
      },
      {
        rank: 4,
        industryId: 1219,
        industryTitle: 'Mining, Resources & Energy',
        roleTitle: 'Lineworker',
        avgSalary: 119185,
        salaryGrowth: 8,
        jobs: 68,
      },
      {
        rank: 5,
        industryId: 1219,
        industryTitle: 'Mining, Resources & Energy',
        roleTitle: 'Allround Operator',
        avgSalary: 126546,
        salaryGrowth: 6.9,
        jobs: 87,
      },
      {
        rank: 6,
        industryId: 1219,
        industryTitle: 'Mining, Resources & Energy',
        roleTitle: 'Trades Assistant',
        avgSalary: 97540,
        salaryGrowth: 6.9,
        jobs: 57,
      },
      {
        rank: 7,
        industryId: 1219,
        industryTitle: 'Mining, Resources & Energy',
        roleTitle: 'Crew Operator',
        avgSalary: 106768,
        salaryGrowth: 6.7,
        jobs: 57,
      },
      {
        rank: 8,
        industryId: 1219,
        industryTitle: 'Mining, Resources & Energy',
        roleTitle: 'Planner',
        avgSalary: 155023,
        salaryGrowth: 6.5,
        jobs: 245,
      },
      {
        rank: 9,
        industryId: 1219,
        industryTitle: 'Mining, Resources & Energy',
        roleTitle: 'Systems Engineer',
        avgSalary: 164871,
        salaryGrowth: 5.1,
        jobs: 33,
      },
      {
        rank: 10,
        industryId: 1219,
        industryTitle: 'Mining, Resources & Energy',
        roleTitle: 'Services Officer',
        avgSalary: 131681,
        salaryGrowth: 5,
        jobs: 42,
      },
      {
        rank: 11,
        industryId: 1219,
        industryTitle: 'Mining, Resources & Energy',
        roleTitle: 'Shift Supervisor',
        avgSalary: 193360,
        salaryGrowth: 4.4,
        jobs: 66,
      },
      {
        rank: 12,
        industryId: 1219,
        industryTitle: 'Mining, Resources & Energy',
        roleTitle: 'Mechanic',
        avgSalary: 145273,
        salaryGrowth: 4.2,
        jobs: 826,
      },
      {
        rank: 13,
        industryId: 1219,
        industryTitle: 'Mining, Resources & Energy',
        roleTitle: 'Mining Supervisor',
        avgSalary: 190814,
        salaryGrowth: 4.1,
        jobs: 41,
      },
      {
        rank: 14,
        industryId: 1219,
        industryTitle: 'Mining, Resources & Energy',
        roleTitle: 'Truck Driver',
        avgSalary: 109122,
        salaryGrowth: 4,
        jobs: 429,
      },
      {
        rank: 15,
        industryId: 1219,
        industryTitle: 'Mining, Resources & Energy',
        roleTitle: 'Site Manager',
        avgSalary: 176294,
        salaryGrowth: 3.5,
        jobs: 44,
      },
      {
        rank: 16,
        industryId: 1219,
        industryTitle: 'Mining, Resources & Energy',
        roleTitle: 'Health, Safety and Environment Adviser',
        avgSalary: 143599,
        salaryGrowth: 3.4,
        jobs: 152,
      },
      {
        rank: 17,
        industryId: 1219,
        industryTitle: 'Mining, Resources & Energy',
        roleTitle: 'Rigger',
        avgSalary: 115419,
        salaryGrowth: 3.3,
        jobs: 138,
      },
    ],
  },
  {
    industryIdFilter: 1221,
    roles: [
      {
        rank: 1,
        industryId: 1221,
        industryTitle: 'Real Estate & Property',
        roleTitle: 'Administration Officer',
        avgSalary: 69247,
        salaryGrowth: 9,
        jobs: 87,
      },
      {
        rank: 2,
        industryId: 1221,
        industryTitle: 'Real Estate & Property',
        roleTitle: 'Management Assistant',
        avgSalary: 61352,
        salaryGrowth: 8,
        jobs: 105,
      },
      {
        rank: 3,
        industryId: 1221,
        industryTitle: 'Real Estate & Property',
        roleTitle: 'Marketing Coordinator',
        avgSalary: 82100,
        salaryGrowth: 7.1,
        jobs: 31,
      },
      {
        rank: 4,
        industryId: 1221,
        industryTitle: 'Real Estate & Property',
        roleTitle: 'Business Development Manager',
        avgSalary: 94744,
        salaryGrowth: 6.6,
        jobs: 201,
      },
      {
        rank: 5,
        industryId: 1221,
        industryTitle: 'Real Estate & Property',
        roleTitle: 'Strata Manager',
        avgSalary: 97216,
        salaryGrowth: 5.7,
        jobs: 305,
      },
      {
        rank: 6,
        industryId: 1221,
        industryTitle: 'Real Estate & Property',
        roleTitle: 'Valuer',
        avgSalary: 98149,
        salaryGrowth: 5.6,
        jobs: 204,
      },
      {
        rank: 7,
        industryId: 1221,
        industryTitle: 'Real Estate & Property',
        roleTitle: 'Property Officer',
        avgSalary: 68194,
        salaryGrowth: 4.4,
        jobs: 123,
      },
      {
        rank: 8,
        industryId: 1221,
        industryTitle: 'Real Estate & Property',
        roleTitle: 'Facilities Coordinator',
        avgSalary: 82847,
        salaryGrowth: 4,
        jobs: 137,
      },
      {
        rank: 9,
        industryId: 1221,
        industryTitle: 'Real Estate & Property',
        roleTitle: 'Property Manager',
        avgSalary: 80508,
        salaryGrowth: 3.2,
        jobs: 3294,
      },
    ],
  },
  {
    industryIdFilter: 6043,
    roles: [
      {
        rank: 1,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Customer Service Representative',
        avgSalary: 64200,
        salaryGrowth: 17,
        jobs: 554,
      },
      {
        rank: 2,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Console Operator',
        avgSalary: 69105,
        salaryGrowth: 13.7,
        jobs: 132,
      },
      {
        rank: 3,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Sales Specialist',
        avgSalary: 72718,
        salaryGrowth: 10.8,
        jobs: 40,
      },
      {
        rank: 4,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Warehouse Assistant',
        avgSalary: 60844,
        salaryGrowth: 9.7,
        jobs: 53,
      },
      {
        rank: 5,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Branch Manager',
        avgSalary: 91023,
        salaryGrowth: 7.7,
        jobs: 136,
      },
      {
        rank: 6,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Store Supervisor',
        avgSalary: 62356,
        salaryGrowth: 6.1,
        jobs: 153,
      },
      {
        rank: 7,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Category Manager',
        avgSalary: 120580,
        salaryGrowth: 5.9,
        jobs: 58,
      },
      {
        rank: 8,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Sales Team Member',
        avgSalary: 55169,
        salaryGrowth: 5.5,
        jobs: 89,
      },
      {
        rank: 9,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Sales Professional',
        avgSalary: 59417,
        salaryGrowth: 5.2,
        jobs: 98,
      },
      {
        rank: 10,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Customer Service Assistant',
        avgSalary: 61945,
        salaryGrowth: 5.1,
        jobs: 64,
      },
      {
        rank: 11,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Assistant Manager',
        avgSalary: 64733,
        salaryGrowth: 4.9,
        jobs: 453,
      },
      {
        rank: 12,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Storeperson',
        avgSalary: 55395,
        salaryGrowth: 4.5,
        jobs: 80,
      },
      {
        rank: 13,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Delivery Driver',
        avgSalary: 56608,
        salaryGrowth: 4.4,
        jobs: 55,
      },
      {
        rank: 14,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Store Manager',
        avgSalary: 66440,
        salaryGrowth: 4,
        jobs: 6778,
      },
      {
        rank: 15,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Counter Manager',
        avgSalary: 61350,
        salaryGrowth: 4,
        jobs: 53,
      },
      {
        rank: 16,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Beauty Adviser',
        avgSalary: 58073,
        salaryGrowth: 3.9,
        jobs: 53,
      },
      {
        rank: 17,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Merchandiser',
        avgSalary: 63141,
        salaryGrowth: 3.8,
        jobs: 967,
      },
      {
        rank: 18,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Boutique Manager',
        avgSalary: 69016,
        salaryGrowth: 3.8,
        jobs: 188,
      },
      {
        rank: 19,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Assistant',
        avgSalary: 59341,
        salaryGrowth: 3.7,
        jobs: 38,
      },
      {
        rank: 20,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Second in Charge',
        avgSalary: 62665,
        salaryGrowth: 3.7,
        jobs: 125,
      },
    ],
  },
  {
    industryIdFilter: 6362,
    roles: [
      {
        rank: 1,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Product Specialist',
        avgSalary: 97724,
        salaryGrowth: 19.1,
        jobs: 37,
      },
      {
        rank: 2,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Sales Agent',
        avgSalary: 69615,
        salaryGrowth: 9.7,
        jobs: 66,
      },
      {
        rank: 3,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Support Officer',
        avgSalary: 71662,
        salaryGrowth: 9.6,
        jobs: 46,
      },
      {
        rank: 4,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Salesperson',
        avgSalary: 69274,
        salaryGrowth: 8.2,
        jobs: 691,
      },
      {
        rank: 5,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Relationship Manager',
        avgSalary: 101938,
        salaryGrowth: 6.7,
        jobs: 168,
      },
      {
        rank: 6,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Success Manager',
        avgSalary: 98079,
        salaryGrowth: 6.5,
        jobs: 100,
      },
      {
        rank: 7,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Showroom Consultant',
        avgSalary: 66621,
        salaryGrowth: 5.7,
        jobs: 46,
      },
      {
        rank: 8,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Appointment Setter',
        avgSalary: 77864,
        salaryGrowth: 5.6,
        jobs: 63,
      },
      {
        rank: 9,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Territory Manager',
        avgSalary: 88796,
        salaryGrowth: 5.2,
        jobs: 424,
      },
      {
        rank: 10,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Sales Representative',
        avgSalary: 81283,
        salaryGrowth: 5,
        jobs: 2901,
      },
      {
        rank: 11,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Sales Engineer',
        avgSalary: 108163,
        salaryGrowth: 4.8,
        jobs: 166,
      },
      {
        rank: 12,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Customer Service and Sales Consultant',
        avgSalary: 68907,
        salaryGrowth: 4.8,
        jobs: 62,
      },
      {
        rank: 13,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Sales Executive',
        avgSalary: 88905,
        salaryGrowth: 3.8,
        jobs: 746,
      },
      {
        rank: 14,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Sales Associate',
        avgSalary: 63116,
        salaryGrowth: 3.8,
        jobs: 300,
      },
      {
        rank: 15,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Business Development Consultant',
        avgSalary: 89682,
        salaryGrowth: 3.7,
        jobs: 46,
      },
      {
        rank: 16,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Sales Coordinator',
        avgSalary: 71899,
        salaryGrowth: 3.5,
        jobs: 251,
      },
      {
        rank: 17,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Operations Manager',
        avgSalary: 125878,
        salaryGrowth: 3.3,
        jobs: 44,
      },
      {
        rank: 18,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Sales Assistant',
        avgSalary: 63714,
        salaryGrowth: 3,
        jobs: 127,
      },
    ],
  },
  {
    industryIdFilter: 1223,
    roles: [
      {
        rank: 1,
        industryId: 1223,
        industryTitle: 'Science & Technology',
        roleTitle: 'Laboratory Manager',
        avgSalary: 113800,
        salaryGrowth: 12.1,
        jobs: 36,
      },
      {
        rank: 2,
        industryId: 1223,
        industryTitle: 'Science & Technology',
        roleTitle: 'Technician',
        avgSalary: 75637,
        salaryGrowth: 6.9,
        jobs: 34,
      },
    ],
  },
  {
    industryIdFilter: 1224,
    roles: [
      {
        rank: 1,
        industryId: 1224,
        industryTitle: 'Sport & Recreation',
        roleTitle: 'Membership Consultant',
        avgSalary: 67830,
        salaryGrowth: 12.5,
        jobs: 62,
      },
      {
        rank: 2,
        industryId: 1224,
        industryTitle: 'Sport & Recreation',
        roleTitle: 'Duty Manager',
        avgSalary: 75839,
        salaryGrowth: 10.7,
        jobs: 33,
      },
      {
        rank: 3,
        industryId: 1224,
        industryTitle: 'Sport & Recreation',
        roleTitle: 'Gym Manager',
        avgSalary: 72183,
        salaryGrowth: 4.5,
        jobs: 37,
      },
      {
        rank: 4,
        industryId: 1224,
        industryTitle: 'Sport & Recreation',
        roleTitle: 'Lifeguard',
        avgSalary: 65475,
        salaryGrowth: 4.4,
        jobs: 63,
      },
      {
        rank: 5,
        industryId: 1224,
        industryTitle: 'Sport & Recreation',
        roleTitle: 'Coordinator',
        avgSalary: 78768,
        salaryGrowth: 3.6,
        jobs: 40,
      },
      {
        rank: 6,
        industryId: 1224,
        industryTitle: 'Sport & Recreation',
        roleTitle: 'Teacher',
        avgSalary: 64865,
        salaryGrowth: 3.6,
        jobs: 116,
      },
      {
        rank: 7,
        industryId: 1224,
        industryTitle: 'Sport & Recreation',
        roleTitle: 'Club Manager',
        avgSalary: 71218,
        salaryGrowth: 3,
        jobs: 269,
      },
      {
        rank: 8,
        industryId: 1224,
        industryTitle: 'Sport & Recreation',
        roleTitle: 'Operations Manager',
        avgSalary: 86354,
        salaryGrowth: 3,
        jobs: 56,
      },
    ],
  },
  {
    industryIdFilter: 1225,
    roles: [
      {
        rank: 1,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Trolley Return Assistant',
        avgSalary: 50500,
        salaryGrowth: 16.6,
        jobs: 40,
      },
      {
        rank: 2,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Support Officer',
        avgSalary: 77826,
        salaryGrowth: 15,
        jobs: 51,
      },
      {
        rank: 3,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Bricklayer',
        avgSalary: 90568,
        salaryGrowth: 14,
        jobs: 78,
      },
      {
        rank: 4,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Cleaning Attendant',
        avgSalary: 57511,
        salaryGrowth: 13.1,
        jobs: 59,
      },
      {
        rank: 5,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Clinic Manager',
        avgSalary: 73421,
        salaryGrowth: 12.5,
        jobs: 42,
      },
      {
        rank: 6,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Plasterer',
        avgSalary: 87314,
        salaryGrowth: 11.5,
        jobs: 108,
      },
      {
        rank: 7,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Tiler',
        avgSalary: 87497,
        salaryGrowth: 11.4,
        jobs: 168,
      },
      {
        rank: 8,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Heating, Ventilation and Air Conditioning Technician',
        avgSalary: 104476,
        salaryGrowth: 11.3,
        jobs: 341,
      },
      {
        rank: 9,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Waterproofer',
        avgSalary: 81919,
        salaryGrowth: 11.1,
        jobs: 36,
      },
      {
        rank: 10,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Removalist',
        avgSalary: 78575,
        salaryGrowth: 10.9,
        jobs: 33,
      },
      {
        rank: 11,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Tinter',
        avgSalary: 75052,
        salaryGrowth: 10.5,
        jobs: 62,
      },
      {
        rank: 12,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Finisher',
        avgSalary: 88179,
        salaryGrowth: 10.5,
        jobs: 93,
      },
      {
        rank: 13,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Trainer',
        avgSalary: 98455,
        salaryGrowth: 10.1,
        jobs: 56,
      },
      {
        rank: 14,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Parts Manager',
        avgSalary: 88520,
        salaryGrowth: 9.6,
        jobs: 79,
      },
      {
        rank: 15,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Store Manager',
        avgSalary: 89794,
        salaryGrowth: 9.4,
        jobs: 156,
      },
      {
        rank: 16,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Electrical and Instrumentation Technician',
        avgSalary: 132868,
        salaryGrowth: 9.4,
        jobs: 117,
      },
      {
        rank: 17,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Offsider',
        avgSalary: 72359,
        salaryGrowth: 8.9,
        jobs: 56,
      },
      {
        rank: 18,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Customer Service Representative',
        avgSalary: 72426,
        salaryGrowth: 8.8,
        jobs: 35,
      },
      {
        rank: 19,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Greenkeeper',
        avgSalary: 65414,
        salaryGrowth: 8.7,
        jobs: 116,
      },
      {
        rank: 20,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Team Member',
        avgSalary: 66429,
        salaryGrowth: 8.6,
        jobs: 141,
      },
    ],
  },
];
